import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const teamDraftAtom = atomWithStorage("WOG_team_draft", "");
export const newsDraftAtom = atom("");
export const challengesDraftAtom = atom("");
